<template>
  <section class="notice">
    <h2 class="notice__title">Notice</h2>
    <ol class="notice__list">
      <!-- 上位1つで、中身が空の場合は飛ばす    -->
      <li class="notice__list--item" v-for="item in NoticeListFilters.slice(0, 2)" :key="item.id">
        <router-link
          :to="{
            path: `/${langPath}notice`,
            query: { id: item.id },
          }"
          class="notice-link"
        >
          <div class="notice-detail">
            <time class="notice-date">
              {{ item.time }}
            </time>
          </div>
          <div class="notice-description">
            {{ item.title[lang] }}
          </div>
        </router-link>
      </li>
    </ol>
  </section>
</template>

<script>
import NoticeList from "../../../assets/constants/top/notice-list";
export default {
  data() {
    return {
      NoticeListFilters: [],
    };
  },
  created() {
    this.NoticeListFilters = NoticeList.items
      .filter((item) => item.title[this.lang] !== "")
      .reverse();
  },
  props: {
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
  },
  name: "noticeList",
};
</script>

<style scoped lang="scss">
$pageColor: #000;
.notice {
  margin: 100px 0 0 0;
  text-align: center;

  &__title {
    display: inline-block;
    padding: 0;
    line-height: 1;
    font-size: 100px;
    font-weight: 900;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_results.svg");
      margin-top: 8px;
    }
  }

  &__list {
    margin: 80px 0 0 0;
    text-align: left;

    &--item {
      border-bottom: solid 1px $pageColor;

      &:hover {
        background-color: #eee;
        transition-duration: 0.3s;
      }

      .notice-link {
        display: block;
        padding: 20px 0;

        .notice-detail {
          display: flex;

          .notice-date {
            font-size: 16px;
            font-weight: bold;
          }
        }
        .notice-description {
          margin: 12px 0 0 0;
          font-size: 20px;
          line-height: 1.4;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/top/NoticeList.vue